import React, { Component } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, DropdownButton, MenuItem } from 'react-bootstrap';
import Selection from '../Common/selection';
import DetailedSelection from '../Common/detailedSelection';
import InputField from '../Common/inputField';
import Spinner from '../Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

class NewFavoriteModal extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        inventoryOptions: []
      }
    }

    componentDidMount() {
        this.props.fetchInventories();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.inventoryItems && nextProps.inventoryItems != this.props.inventoryItems) {
        var inventoryItemOptions = [{value: '', label: "No.       |  Name           |  Description"}];
        nextProps.inventoryItems.map(inventoryItem => {
          let text = "                                                              ";
          let output = [inventoryItem.ProductNum.slice(0, 8), text].join('');
          output = [output.slice(0,8), '  |  ', inventoryItem.Name.slice(0,12), text].join('');
          output = [output.slice(0,26), '  |  ', inventoryItem.Description.slice(0,50), text].join('');
          output = output.slice(0,86);
          inventoryItemOptions.push({ value: inventoryItem.Product_id, label: output})
        });
        console.log("inventoryOptions", inventoryItemOptions);
        this.setState({inventoryOptions: inventoryItemOptions});
      }
    }

    handleFormSubmit(formProps) {
        const { inventoryItems, closeA, SalesFavoriteList_id, currentList } = this.props;
        console.log("inventoryItems", inventoryItems);
        console.log("formProps", formProps)
        console.log("currentList", currentList)
        let check = _.findIndex(currentList.rows, { 'Product_id': formProps.InventoryItem_id.value });
        if (check > -1) {
          this.props.inListError();
          return;
        } else {
          this.props.clearInListError();
        }
        const index = _.findIndex(inventoryItems, { 'Product_id': formProps.InventoryItem_id.value });

        let newFav = {...inventoryItems[index]};
        console.log("newfav", inventoryItems[index]);
        newFav.ProductName = inventoryItems[index].Name
        console.log(newFav);
        // if (inventoryItems[index].Product) {
        //   newFav.ProductName = inventoryItems[index].Product["Name"];
        // }
        if(SalesFavoriteList_id) {
          // this.props.addNewCustomerFavorite(newFav, SalesFavoriteList_id);
        } else {
          console.log("ABOUT TO CALL", newFav)
          this.props.addNewFavorite(newFav);
        }
        console.log("about to call closeA");
        closeA(inventoryItems[index]);
    }

    moveToFavotitesList() {

    }

    renderInventoryItems() {
      if (this.props.isLoading) return <Col sm={ 12 } className="marginTopStyle"><Spinner/></Col>
      else {
        return (
          <Col sm={ 12 } className="marginTopStyle">
            <label className="centerStyle" ><Translate value="select_an_inventory_item" defaultMessage="Select an Inventory Item" description="Select an Inventory Item"/></label>
            <Field name="InventoryItem_id" component={DetailedSelection} options={this.state.inventoryOptions}/>
          </Col>
        )
      }
    }

    renderAddItemResults() {
      if (!this.props.inList)
        return;
      else
        return <ContentWrapper><div className="alert alert-danger"><Translate value="item_already_in_list" /></div></ContentWrapper>
    }

    // Once User choose a Template, show him some detail
    renderInventoryItemDetail(id) {
        const { inventoryItems } = this.props;
        const index = _.findIndex(inventoryItems, { 'id': id });
        if (index > -1) {
            var description;
            var name;
            var refPurchasePrice;

            if(inventoryItems[index].ProductNum) {
              if(inventoryItems[index].ProductNum.Description) {
                description = inventoryItems[index].ProductNum.Description;
              } else {
                description = '';
              }
              if(inventoryItems[index].ProductNum.Name) {
                name = inventoryItems[index].ProductNum.Name;
              } else {
                name = '';
              }
            }
            if(inventoryItems[index].RefPurchasingPrice) {
              refPurchasePrice = inventoryItems[index].RefPurchasingPrice;
            } else {
              refPurchasePrice = '';
            }

            if(description && name && refPurchasePrice) {
              return (
                  <div>
                      <br/>
                      <Row><Col sm={ 12 }>
                          Inventory Item Name: {name}
                      </Col></Row>
                      <Row><Col sm={ 12 }>
                          Description: {description}
                      </Col></Row>
                      <Row><Col sm={ 12 }>
                          Ref Purchase Price: {refPurchasePrice}
                      </Col></Row>
                  </div>
                )
              }

        }
    }

    render() {
        const { handleSubmit, closeC, submitting, pristine, inventoryItemValue } = this.props;
        let height = (40).toString();
        let tableCollapseFix = {height: height};
        return (
            <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                <Row style={ tableCollapseFix }>
                      {this.renderInventoryItems()}
                </Row>
                {inventoryItemValue && this.renderInventoryItemDetail(inventoryItemValue.value) }
                <br/>
                <br/>
                <ButtonToolbar>
                    <Button
                      bsStyle="success"
                      type="submit"
                      action="submit"
                      disabled={ submitting } >
                      <em className="fa fa-save" /><Translate value="add_new_favorite" defaultMessage="Add New Favorite" description="save"/>
                    </Button>
                    <Button
                      bsStyle="danger"
                      type="reset"
                      onClick={(event) => { event.preventDefault(); closeC(); this.props.clearInListError() } } >
                      <em className="fa fa-close" /><Translate value="cancel" defaultMessage="Cancel" description="Cancel"/>
                    </Button>
                </ButtonToolbar>
                <Row>
                  <Col sm={ 4 } />
                  <Col sm={ 4 }>
                    {this.renderAddItemResults()}
                  </Col>
                </Row>
            </form>
        )
    }
}

export default NewFavoriteModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Favorites/favoriteModal.jsx